// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__14P9B","footer_logo":"footer_logo__1TGSI","footer_link":"footer_link__1Xgw_","reference":"reference__26LtN"};


//////////////////
// WEBPACK FOOTER
// ./components/footer/style.css
// module id = ZMjw
// module chunks = 0 7 8 9 10 11 12